import { BaseRemoteService } from "@ofqual/portal-core/core/dataAccess";
import { Opts } from "@ofqual/portal-core/core/types";
import { ConflictResponse } from "../domain/ConflictResponse";

export type SarsRequiredItem = {
  requestType: number[];
  sarContactMethod: number;
};

export class SarsService extends BaseRemoteService {
  public async createSar(
    peId: string,
    sarsRequireItem: SarsRequiredItem,
    opts: Opts
  ): Promise<ConflictResponse> {
    const url = `${this.apiRoot}/sars/${peId}/createfrompe`;
    try {
      const response = await super.postRequest<any>(url, sarsRequireItem, opts);
      return { data: response, status: 204, error: null };
    } catch (e: any) {
      if (e.status === 409 || e.status === 404) {
        return { data: e.message, status: e.status, error: e.error };
      } else {
        throw e;
      }
    }
  }

  public async getSarFromPeId(id: string, opts: Opts): Promise<any> {
    console.log ("hey gringo!!!")
    const url = `${this.apiRoot}/sars/${id}/sarforpe`;
    try {
      const response = await super.getRequest<any>(url, opts);
      return { data: response, status: 204, error: null };
    } catch (e: any) {
      if (e.status === 404) {
        return { data: e.message, status: e.status, error: e.error };
      }
    }
  }

  public async getSar(id: string, opts: Opts): Promise<any> {
    const url = `${this.apiRoot}/sars/${id}`;
    const response = await super.getRequest<any>(url, opts);
    return response;
  }
}
